import {apiRequest} from '.'


export const addToPayroll = async (token, data)=>{
    try{
        const response = await apiRequest({
            url: '/payroll',
            method: 'POST',
            data: data,
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}

export const updatePayroll = async (token, data, id)=>{
    try{
        const response = await apiRequest({
            url: `/payroll/${id}`,
            method: 'POST',
            data: data,
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}

export const fetchPayrolls = async (token)=>{
    try{
        const response = await apiRequest({
            url: '/payroll',
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}